import Udesk from 'Udesk';
import Component from './coach-template';

export default Udesk.react.udeskify(Component);
